import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  MenuBook,
  Visibility,
  People,
  RecordVoiceOver,
  Gavel,
  Description,
  Receipt,
  Info,
} from "@material-ui/icons";
import {
  EasyNavigationCard,
  EasyNavigationContainer,
} from "./easyNavigation.styles";
import { Section, SectionTitle } from "components/section";
import { useAppState } from "main/context/app-context";

export const EasyNavigationSection = () => {
  const { applicationData } = useAppState();
  const navigate = useNavigate();

  const isExternalUrl = (url: string): boolean => {
    return url.startsWith("http://") || url.startsWith("https://");
  };

  const handleNavigation = (route: string) => {
    if (isExternalUrl(route)) {
      window.open(route, "_blank");
    } else {
      navigate(route);
    }
  };

  const easyNavigationItems = useMemo(() => {
    if (!applicationData?.entity?.serviceUrls) return [];

    const items = [];
    const serviceUrls = applicationData.entity.serviceUrls;

    if (serviceUrls.urlDiarioOficial) {
      items.push({
        label: "DIÁRIO OFICIAL",
        Icon: MenuBook,
        route: serviceUrls.urlDiarioOficial,
      });
    } else {
      items.push({
        label: "DIÁRIO OFICIAL",
        Icon: MenuBook,
        route: "/publicacoes/diario-oficial",
      });
    }

    if (serviceUrls.urlTransparencia) {
      items.push({
        label: "TRANSPARÊNCIA",
        Icon: Visibility,
        route: serviceUrls.urlTransparencia,
      });
    }

    if (serviceUrls.urlServidores) {
      items.push({
        label: "SERVIDORES",
        Icon: People,
        route: serviceUrls.urlServidores,
      });
    }

    if (serviceUrls.urlOuvidoria) {
      items.push({
        label: "OUVIDORIA",
        Icon: RecordVoiceOver,
        route: serviceUrls.urlOuvidoria,
      });
    }

    if (serviceUrls.urlLicitacoes) {
      items.push({
        label: "LICITAÇÕES",
        Icon: Gavel,
        route: serviceUrls.urlLicitacoes,
      });
    }

    if (serviceUrls.urlContratos) {
      items.push({
        label: "CONTRATOS",
        Icon: Description,
        route: serviceUrls.urlContratos,
      });
    }

    if (serviceUrls.urlNotaFiscal) {
      items.push({
        label: "NOTA FISCAL",
        Icon: Receipt,
        route: serviceUrls.urlNotaFiscal,
      });
    }

    if (serviceUrls.urlSic) {
      items.push({
        label: "E-SIC",
        Icon: Info,
        route: serviceUrls.urlSic,
      });
    }

    return items;
  }, [applicationData?.entity?.serviceUrls]);

  if (easyNavigationItems.length === 0) {
    return null;
  }

  return (
    <Section background="gray">
      <SectionTitle>Acesso rápido</SectionTitle>
      <EasyNavigationContainer>
        {easyNavigationItems.map((item) => {
          const IconComponent = item.Icon;
          return (
            <EasyNavigationCard
              onClick={() => handleNavigation(item.route)}
              key={item.label}
            >
              <IconComponent style={{ fontSize: 48, color: 'inherit' }} />
              <span>{item.label}</span>
            </EasyNavigationCard>
          );
        })}
      </EasyNavigationContainer>
    </Section>
  );
};
